export default "__VITE_ASSET__Nb4zfRVZ__"